import { store } from "@/store";
import { InboxStore } from "@/store/constants";
import { doc, getFirestore, updateDoc } from "firebase/firestore";

export const snoozeConversation = async (id: string, date: Date) => {
  const chatbotId = store.getters[InboxStore.Getters.GET_CHATBOT_ID];
  await updateDoc(
    doc(getFirestore(), "dialogs/" + chatbotId + "/chats/" + id),
    {
      snoozed: date,
      archived: false,
    }
  );
};
